import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Option from "./Option";
import withFormHandlers from "theme/components/atoms/Form/Input/withFormHandlers";
import Checkbox from "theme/components/atoms/Form/Input/Checkbox";

const getNewValues = (isSelected, value, option) => {
  if (!isSelected) {
    return value.filter((value) => value !== option.value);
  } else {
    return value.concat(option.value);
  }
};

const OptionPicker = ({
  appearance,
  options,
  id,
  name,
  value,
  onChange,
  attribute,
}) => {
  const optionsView = options.map((option) => {
    let isSelected = value ? value.indexOf(option.value) !== -1 : false;
    const isDisabled = option.docCount === 0;
    const elementClasses = classNames("option-picker__element", {
      "option-picker__element--disabled": isDisabled,
    });

    return (
      <div key={option.value} className={elementClasses}>
        {appearance === "checkbox" ? (
          <Checkbox
            id={`${id}-${option.value}`}
            name={`${name}-${option.value}`}
            value={option.value}
            label={
              <>
                {option.label}{" "}
                {option.docCount !== null && option.docCount !== undefined ? (
                  <span className="option-picker__count">
                    ({option.docCount})
                  </span>
                ) : undefined}
              </>
            }
            checked={isSelected}
            onChange={(isSelected) => {
              onChange(getNewValues(isSelected, value, option));
            }}
            disabled={isDisabled}
          />
        ) : (
          <Option
            onClick={(event) => {
              event.currentTarget.blur();
              onChange(getNewValues(!isSelected, value, option));
            }}
            appearance={appearance}
            selected={isSelected}
            option={option}
            attribute={attribute}
            disabled={isDisabled}
          ></Option>
        )}
      </div>
    );
  });

  return (
    <div
      className={classNames("option-picker", {
        [`option-picker--${appearance}`]: appearance,
      })}
    >
      <input name={name} id={name} type="hidden" value={value} />
      {optionsView}
    </div>
  );
};

OptionPicker.propTypes = {
  appearance: PropTypes.oneOf(["buttons", "checkbox", "swatch"]),
  options: PropTypes.array.isRequired,
};

export default withFormHandlers({
  dirtyOnChange: true,
  getValueFromEvent: (value) => value,
})(OptionPicker);
